export default __webpack_public_path__ + "static/media/close.f24f130f.svg";